// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This is literally the Trello logo made out of CSS, so it needs
exact colors and can't use ADS design tokens. It's done this way
so the selected board's background can also be used as the
background image of the logo.
*/
.XH_obIIOBwpohe {
  box-sizing: border-box;
  width: 96px;
  height: 96px;
  clear: both;
  border-radius: 9px;
  background-color: #0079bf;
  background-size: 100%;
  font-size: 0;
  text-align: left;
}
.XH_obIIOBwpohe::before,
.XH_obIIOBwpohe::after {
  content: '';
  display: inline-block;
  width: 30px;
  height: 66px;
  margin: 12px 0 0 12px;
  border-radius: 4.5px;
  background-color: white;
  vertical-align: top;
}
.XH_obIIOBwpohe::after {
  height: 33px;
  margin-left: 12px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trelloBoardIcon": `XH_obIIOBwpohe`
};
export default ___CSS_LOADER_EXPORT___;
